export default {
  SET_RESERVATION_STATUSES (state, reservation_statuses) {
    state.reservation_statuses = reservation_statuses
  },
  REMOVE_RECORD (state, itemId) {
    const reservationStatusIndex = state.reservation_statuses.findIndex((u) => u.id === itemId)
    state.reservation_statuses.splice(reservationStatusIndex, 1)
  }
}
